/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { addCropData, copyCrop, createQuotation, deleteCropById, editCropData, getCropById, getCropData, getSchedulesByCropId } from "../api/api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Loading from "../components/Loading";
import { FaFileInvoice, FaEdit, FaTrash } from "react-icons/fa";
import bannerImg from "../assets/banner.jpg";
import leaf from "../assets/Greenleaf.png";
import { useRef } from "react";
import { FaCopy } from "react-icons/fa";
import { motion } from "framer-motion";

function CropList() {
  const [cropList, setCropList] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isCopyDialogOpen, setIsCopyDialogOpen] = useState(false);
  const [newCrop, setNewCrop] = useState({ name: "", description: "", weeks: "" });
  const [editCropId, setEditCropId] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [acreValue, setAcreValue] = useState(0);
  const [acreValues, setAcreValues] = useState({});

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedScheduleId, setSelectedScheduleId] = useState(false);
  const [selectedCropId, setSelectedCropId] = useState("");
  const [farmerInfo, setFarmerInfo] = useState({
    _id: "",
    name: "",
    place: "",
    tahsil: "",
    district: "",
    state: "",
    number: "",
    email: "",
  });
  const [searchTerm, setSearchTerm] = useState("");

  const modalRef = useRef(null);

  // Fetch crops
  useEffect(() => {
    setLoading(true);
    fetchCrops();
  }, []);

  const fetchCrops = async () => {
    const res = await getCropData();
    if (res.data) {
      setCropList(res.data);
      setLoading(false);
    } else {
      toast.warning("Unable to fetch Data!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
        // transition: Bounce,
      });
      setLoading(false);
      setCropList([]);
    }
  };

  // Handle create/update
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newCrop.weeks <= 0) {
      toast.warning("ॲप्लिकेशन संख्या 0 किंवा त्यापेक्षा कमी असू शकत नाही!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
        // transition: Bounce,
      });
      return;
    }

    if (editCropId) {
      const res = await editCropData(editCropId, newCrop);
    } else {
      const res = await addCropData(newCrop);
    }
    fetchCrops();
    setIsDialogOpen(false);
    setNewCrop({ name: "", weeks: "", description: "" });
    setEditCropId(null);
  };

  // Handle edit
  const handleEdit = (crop) => {
    setNewCrop({ name: crop.name, weeks: crop.weeks, description: crop.description });
    setEditCropId(crop._id);
    setIsDialogOpen(true);
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: "Confirm to delete",
      message: "आपणास हा पिक खरोखर हटवायचा आहे का? / Do you really want to delete this crop?",

      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const toastId = toast.loading("Deleting crop...");

            try {
              await deleteCropById(id);
              fetchCrops();

              toast.update(toastId, {
                render: "Crop deleted successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
                position: "top-center",
              });
            } catch (error) {
              toast.error(toastId, {
                render: "Failed to delete crop",
                type: "error",
                isLoading: false,
                autoClose: 3000,
                position: "top-center",
              });
            }
          },
        },
        {
          label: "No",
          onClick: () => {
            // Do nothing
          },
        },
      ],
    });
  };

  const handleSubmitCopyCrop = async (e) => {
    e.preventDefault();
    try {
      if (!selectedCropId) {
        toast.error("No crop selected to copy");
        return;
      }

      const payload = {
        name: newCrop.name,
        description: newCrop.description,
        weeks: newCrop.weeks,
        weekInterval: newCrop.weekInterval,
      };

      const res = await copyCrop(selectedCropId, payload);
      toast.success(`Crop copied successfully: ${res.newCrop.name}`);
      setIsCopyDialogOpen(false);
      fetchCrops();
      setNewCrop({ name: "", description: "", weeks: "", weekInterval: "" });
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to copy crop");
    }
  };

  const handleCopyCrop = async (id) => {
    setIsCopyDialogOpen(true);
    setSelectedCropId(id);
    // try {
    //   // console.log("res._id ",res._id);

    //   // const res = await getCropById(id);
    //   const res = await getSchedulesByCropId(id);
    //   if (res) {
    //     console.log("res ", res);
    //   }
    // } catch (error) {
    //   toast.error(error?.response?.data?.message || "Failed to get crop");
    // }
  };

  // handleSubmit()

  const handleGenerateQuotation = async (cropId, farmerData) => {
    setLoading(true);
    try {
      const crop = await getCropById(cropId);
      const schedule = await getSchedulesByCropId(cropId);

      const acreValue = acreValues[cropId];
      const acres = Number(acreValue);
      const allProducts = (schedule.weeks || []).flatMap((week) => week.products || []);

      // 🗓️ Selected new start date by user
      const newStartDate = farmerData.startDate ? new Date(farmerData.startDate) : new Date();

      // 🗓️ Compute date intervals (differences in days between each original week)
      let dateDiffs = [];
      if (schedule.weeks.length > 1) {
        for (let i = 1; i < schedule.weeks.length; i++) {
          const prev = new Date(schedule.weeks[i - 1].date);
          const curr = new Date(schedule.weeks[i].date);
          const diffDays = Math.round((curr - prev) / (1000 * 60 * 60 * 24));
          dateDiffs.push(diffDays);
        }
      }

      // 🧮 Build updatedWeeks with shifted dates
      const updatedWeeks = schedule.weeks.map((week, index) => {
        let newWeekDate;

        if (newStartDate) {
          if (index === 0) {
            // First week = selected start date
            newWeekDate = new Date(newStartDate);
          } else {
            // Add previous intervals cumulatively
            const daysToAdd = dateDiffs.slice(0, index).reduce((sum, d) => sum + d, 0);
            newWeekDate = new Date(newStartDate);
            newWeekDate.setDate(newStartDate.getDate() + daysToAdd);
          }
        } else {
          // fallback: use original date if startDate not selected
          newWeekDate = new Date(week.date);
        }

        return {
          ...week,
          date: newWeekDate.toISOString().split("T")[0], // Keep in YYYY-MM-DD format
          totalWater: String(acres * Number(week.waterPerAcre || 0)),
          totalAcres: String(acres),
          productAmountMg: String(acres * Number(week.productAmountMg || 0)),
          productAmountLtr: String(acres * Number(week.productAmountLtr || 0)),
          products: (week.products || []).map((prod) => {
            const [mlPart, lPart] = (prod.quantity || "").split("&").map((q) => q.trim());
            const ml = parseFloat(mlPart?.split(" ")[0]) || 0;
            const mlUnit = mlPart?.split(" ")[1] || "ml/grm";
            const l = parseFloat(lPart?.split(" ")[0]) || 0;
            const lUnit = lPart?.split(" ")[1] || "ltr/kg";
            const repeatCount = allProducts.filter((p) => p.name === prod.name).length;

            return {
              name: prod.name,
              quantity: `${(ml * acres).toFixed(2)} ${mlUnit} & ${(l * acres).toFixed(3)} ${lUnit}`,
              perLitreMix: prod.perLitreMix,
              price: Number(prod.pricePerAcre * acres * repeatCount).toFixed(2),
              instruction: prod.instruction,
              category: prod.category,
              rate: prod.rate,
            };
          }),
        };
      });

      const quotationPayload = {
        cropId,
        cropName: crop.name,
        acres,
        weeks: updatedWeeks,
        farmerInfo: farmerData,
        scheduleId: selectedScheduleId,
        createdBy: JSON.parse(sessionStorage.getItem("user"))?._id || "",
      };

      const res = await createQuotation(quotationPayload);
      toast.success("Quotation created successfully");
      setLoading(false);
      setAcreValues({});
      setFarmerInfo({
        _id: "",
        name: "",
        place: "",
        tahsil: "",
        district: "",
        state: "",
        startDate: "",
        number: "",
        email: "",
      });
      const quotationId = res._id;

      navigate(`/schedule/quotation/${quotationId}`);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to generate quotation");
      fetchCrops();
    } finally {
      setLoading(false);
    }
  };

  const promptFarmerDetails = () => {
    return new Promise((resolve) => {
      const name = prompt("Enter Farmer Name:");
      if (!name) return resolve(null);

      const place = prompt("Enter Place:");
      const tahsil = prompt("Enter Tahsil:");
      const district = prompt("Enter District:");
      const state = prompt("Enter State:");

      resolve({ name, place, tahsil, district, state });
    });
  };

  const [sortBy, setSortBy] = useState("createdAt"); // default sort by name

  const sortedCropList = cropList
    // 🔹 search filter
    .filter((crop) => crop.name.toLowerCase().includes(searchTerm.toLowerCase()))

    // 🔹 unapproved filter
    .filter((crop) => {
      if (sortBy === "unapproved") {
        return crop.approved === false;
      }
      return true;
    })

    // 🔹 sorting
    .sort((a, b) => {
      if (sortBy === "name") return a.name.localeCompare(b.name);
      if (sortBy === "weeks") return a.weeks - b.weeks;
      if (sortBy === "createdAt") return new Date(b.createdAt) - new Date(a.createdAt);

      // for unapproved, keep newest first
      if (sortBy === "unapproved") {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }

      return 0;
    });

  const [userData, setUserData] = useState(null);

  // Load logged in user
  useEffect(() => {
    const loggedInUser = JSON.parse(sessionStorage.getItem("user"));
    setUserData(loggedInUser);

    if (loggedInUser) {
      setFarmerInfo({
        _id: loggedInUser._id || "",
        name: loggedInUser.name || "",
        place: loggedInUser.place || "",
        tahsil: loggedInUser.tahsil || "",
        district: loggedInUser.district || "",
        state: loggedInUser.state || "",
        number: loggedInUser.number || "",
        email: loggedInUser.email || "",
        startDate: "",
      });
    }
  }, []);

  const canEdit = userData?.role === "admin" || userData?.canEditSchedule;
  const canSee = userData?.role === "admin" || userData?.canSeeSchedule || userData?.canRemoveSchedule;
  const canDelete = userData?.role === "admin" || userData?.canRemoveSchedule;

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="p-6 max-w-6xl mx-auto">
          {/* Page Header */}
          <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
            <h1 className="text-3xl font-bold text-green-800">Crop List</h1>

            <div className="flex flex-wrap items-center gap-3">
              {/* 🔍 Search Box */}
              <input
                type="text"
                placeholder="Search Crop Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border border-green-300 rounded-lg p-2 text-sm text-green-700 placeholder-green-400 focus:outline-none focus:ring-2 focus:ring-green-400"
              />

              {/* 🔽 Sort Dropdown */}
              <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="border border-green-300 rounded-lg p-2 text-sm text-green-700">
                <option value="createdAt">Sort by Date (Newest)</option>
                <option value="name">Sort by Name</option>
                <option value="weeks">Sort by Weeks</option>
                <option value="unapproved">Unapproved Schedules</option>
              </select>

              {/* ➕ Add Button */}
              {canEdit && (
                <button
                  onClick={() => {
                    setIsDialogOpen(true);
                    setEditCropId(null);
                    setNewCrop({ name: "", weeks: "", description: "" });
                  }}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-5 py-2 rounded-lg shadow-md transition"
                >
                  + Add Crop
                </button>
              )}
            </div>
          </div>

          {/* Crop List */}
          <div className="space-y-4">
            {sortedCropList.map((crop, index) => (
              <motion.div
                key={crop._id}
                className="bg-white border border-green-200 rounded-xl shadow-sm p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 hover:shadow-md transition"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                {/* Crop Info */}
                <div className="flex-1">
                  {canEdit ? (
                    <Link to={`/form1?name=${encodeURIComponent(crop.name)}&weeks=${crop.weeks}&id=${crop._id}`} className="text-lg font-semibold text-green-900 hover:underline">
                      {crop.name} – {crop.weeks} weeks
                    </Link>
                  ) : canSee ? (
                    <Link to={`/schedule/${crop._id}`} className="text-lg font-semibold text-green-900 hover:underline">
                      {crop.name} – {crop.weeks} weeks
                    </Link>
                  ) : (
                    <div className="text-lg font-semibold text-green-900">
                      {crop.name} – {crop.weeks} weeks
                    </div>
                  )}
                  {crop.description && <p className="text-sm text-gray-600 mt-1">{crop.description}</p>}
                </div>

                {/* Acres Input */}
                <input
                  type="number"
                  placeholder="Acres"
                  step="any"
                  className="border border-green-300 p-2 rounded-lg w-24 text-center focus:outline-none focus:ring-2 focus:ring-green-500"
                  value={acreValues[crop._id] || ""}
                  onChange={(e) =>
                    setAcreValues((prev) => ({
                      ...prev,
                      [crop._id]: e.target.value,
                    }))
                  }
                />

                {/* Action Buttons */}
                <div className="flex flex-wrap gap-2">
                  <button
                    onClick={() => {
                      const acres = parseFloat(acreValues[crop._id]);

                      if (!acres || acres <= 0) {
                        toast.warning("कृपया 0 पेक्षा जास्त एकर प्रविष्ट करा!", {
                          position: "top-center",
                          autoClose: 3000,
                        });
                        return;
                      }

                      // Reset modal fields with latest user data
                      if (userData) {
                        setFarmerInfo({
                          _id: userData._id || "",
                          name: userData.name || "",
                          place: userData.place || "",
                          tahsil: userData.tahsil || "",
                          district: userData.district || "",
                          state: userData.state || "",
                          startDate: "",
                        });
                      }

                      setShowModal(true);
                      setSelectedCropId(crop._id);
                      setSelectedScheduleId(crop.scheduleId);
                    }}
                    className="bg-green-100 text-green-700 hover:bg-green-200 p-2 rounded-full shadow"
                    title="Generate Quotation"
                  >
                    <FaFileInvoice />
                  </button>

                  {crop.hasBill && crop.scheduleId && (
                    <button
                      onClick={() => navigate(`/schedulebill/view/${crop.scheduleId}`)}
                      className="bg-green-100 text-green-700 hover:bg-green-200 p-2 rounded-full shadow"
                      title="View Schedule Bill"
                    >
                      🧾
                    </button>
                  )}

                  {canEdit && (
                    <button onClick={() => handleEdit(crop)} className="bg-yellow-100 text-yellow-700 hover:bg-yellow-200 p-2 rounded-full shadow" title="Edit Crop">
                      <FaEdit />
                    </button>
                  )}

                  {canDelete && (
                    <button onClick={() => handleDelete(crop._id)} className="bg-red-100 text-red-600 hover:bg-red-200 p-2 rounded-full shadow" title="Delete Crop">
                      <FaTrash />
                    </button>
                  )}

                  {canEdit && (
                    <button onClick={() => handleCopyCrop(crop._id)} className="bg-green-100 text-green-600 hover:bg-green-200 p-2 rounded-full shadow" title="Copy Crop">
                      <FaCopy />
                    </button>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Add/Edit Crop Modal */}
          {isDialogOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
              onClick={(e) => {
                if (modalRef.current && !modalRef.current.contains(e.target)) {
                  setIsDialogOpen(false);
                }
              }}
            >
              <div ref={modalRef} className="bg-white border border-green-600 p-6 rounded-2xl shadow-2xl w-[90%] max-w-md relative" onClick={(e) => e.stopPropagation()}>
                {/* Decorative Icon */}
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-green-100 p-2 rounded-full shadow-md">
                  <img src={leaf} alt="Leaf" className="w-8 h-8" />
                </div>

                <h2 className="text-2xl font-bold text-green-700 text-center mt-6 mb-4">{editCropId ? "पिक माहिती अपडेट करा" : "नवीन पीक जोडा"}</h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <input
                    type="text"
                    placeholder="पिकाचे नाव (Crop Name)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.name}
                    onChange={(e) => setNewCrop({ ...newCrop, name: e.target.value })}
                    required
                  />
                  <input
                    type="text"
                    placeholder="पिकाचे वर्णन (Crop Description)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.description}
                    onChange={(e) => setNewCrop({ ...newCrop, description: e.target.value })}
                  />
                  <input
                    type="number"
                    placeholder="ॲप्लिकेशन संख्या (Weeks)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.weeks}
                    onChange={(e) => {
                      const val = e.target.value;
                      setNewCrop({
                        ...newCrop,
                        weeks: val === "" ? "" : Number(val),
                      });
                    }}
                    required
                  />
                  <input
                    type="number"
                    placeholder="ॲप्लिकेशन दरम्यानचा कालावधी (दिवसांत)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.weekInterval}
                    onChange={(e) => {
                      const val = e.target.value;
                      setNewCrop({
                        ...newCrop,
                        weekInterval: val === "" ? "" : Number(val), // store interval instead of weeks
                      });
                    }}
                  />

                  <div className="flex justify-end space-x-3 pt-2">
                    <button type="button" onClick={() => setIsDialogOpen(false)} className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md shadow-sm">
                      रद्द करा
                    </button>
                    <button type="submit" className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md shadow-md">
                      {editCropId ? "अपडेट करा" : "जोडा"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {isCopyDialogOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
              onClick={(e) => {
                if (modalRef.current && !modalRef.current.contains(e.target)) {
                  setIsCopyDialogOpen(false);
                }
              }}
            >
              <div ref={modalRef} className="bg-white border border-green-600 p-6 rounded-2xl shadow-2xl w-[90%] max-w-md relative" onClick={(e) => e.stopPropagation()}>
                {/* Decorative Icon */}
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-green-100 p-2 rounded-full shadow-md">
                  <img src={leaf} alt="Leaf" className="w-8 h-8" />
                </div>

                <h2 className="text-2xl font-bold text-green-700 text-center mt-6 mb-4">{"पिक माहिती अपडेट करा"}</h2>

                <form onSubmit={handleSubmitCopyCrop} className="space-y-4">
                  <input
                    type="text"
                    placeholder="पिकाचे नाव (Crop Name)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.name}
                    onChange={(e) => setNewCrop({ ...newCrop, name: e.target.value })}
                    required
                  />
                  <input
                    type="text"
                    placeholder="पिकाचे वर्णन (Crop Description)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.description}
                    onChange={(e) => setNewCrop({ ...newCrop, description: e.target.value })}
                  />
                  <input
                    type="number"
                    placeholder="ॲप्लिकेशन संख्या (Weeks)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.weeks}
                    onChange={(e) => {
                      const val = e.target.value;
                      setNewCrop({
                        ...newCrop,
                        weeks: val === "" ? "" : Number(val),
                      });
                    }}
                    required
                  />
                  {/* <input
                    type="number"
                    placeholder="ॲप्लिकेशन दरम्यानचा कालावधी (दिवसांत)"
                    className="w-full border border-green-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                    value={newCrop.weekInterval}
                    onChange={(e) => {
                      const val = e.target.value;
                      setNewCrop({
                        ...newCrop,
                        weekInterval: val === "" ? "" : Number(val), // store interval instead of weeks
                      });
                    }}
                  /> */}

                  <div className="flex justify-end space-x-3 pt-2">
                    <button type="button" onClick={() => setIsCopyDialogOpen(false)} className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md shadow-sm">
                      रद्द करा
                    </button>
                    <button type="submit" className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md shadow-md">
                      {editCropId ? "अपडेट करा" : "जोडा"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Farmer Info Modal */}
          {showModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
              <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg space-y-3">
                <h2 className="text-lg font-semibold text-green-700">Farmer Details</h2>
                {/* Standard Text Fields */}
                {["name", "place", "tahsil", "district", "state"].map((field) => (
                  <input
                    key={field}
                    type="text"
                    name={field}
                    placeholder={`Enter ${field}`}
                    value={farmerInfo[field]}
                    onChange={(e) => setFarmerInfo({ ...farmerInfo, [field]: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-sm"
                  />
                ))}

                {/* Specific Field: Mobile Number */}
                <input
                  type="tel"
                  name="number"
                  placeholder="Enter mobile number"
                  value={farmerInfo.number}
                  onChange={(e) => setFarmerInfo({ ...farmerInfo, number: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-sm"
                  maxLength={10} // Optional: Limits to 10 digits
                  pattern="[0-9]*" // Optional: Encourages numeric keypad on mobile
                />

                {/* Specific Field: Email */}
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email address"
                  value={farmerInfo.email}
                  onChange={(e) => setFarmerInfo({ ...farmerInfo, email: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-sm"
                />
                <label className="block mt-2 text-sm text-gray-700">Select Starting Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={farmerInfo.startDate}
                  onChange={(e) => setFarmerInfo({ ...farmerInfo, startDate: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-sm"
                />

                <div className="flex justify-end gap-3 pt-2">
                  <button onClick={() => setShowModal(false)} className="px-4 py-1.5 bg-gray-300 rounded hover:bg-gray-400 text-sm">
                    Cancel
                  </button>

                  <button
                    onClick={() => {
                      handleGenerateQuotation(selectedCropId, farmerInfo);
                      setShowModal(false);
                    }}
                    className="px-4 py-1.5 bg-green-600 text-white rounded hover:bg-green-700 text-sm"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default CropList;
